import * as React from "react";
import { 
    IconButton, 
    Table, 
    TableBody, 
    TableCell, 
    TableHead, 
    TablePagination, 
    TableRow, 
    Typography,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from "@material-ui/core";
import { Planning } from "src/api/model";
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';


export interface TablePlanningComponentProps {
    data: Planning[];
    totalItems: number;
    pageNum: number;
    pageSize: number;
    onPageNumChange: (pageNum: number) => void;
    onPageSizeChange: (pageSize: number) => void;
    onViewDetails?: (planning: Planning) => void;
    onDelete?: (planningId: string) => void;
}

interface TablePlanningComponentState {
    deleteDialogOpen: boolean;
    planningToDelete: Planning | null;
}

export class TablePlanningComponent extends React.Component<TablePlanningComponentProps, TablePlanningComponentState> {
    constructor(props: TablePlanningComponentProps) {
        super(props);
        this.state = {
            deleteDialogOpen: false,
            planningToDelete: null
        };
    }

    handlePageChange = (event: any, newPage: number) => {
        this.props.onPageNumChange(newPage);
    };

    handleRowsPerPageChange = (event: any) => {
        this.props.onPageSizeChange(parseInt(event.target.value, 10));
    };

    handleViewDetails = (planning: Planning) => {
        if (this.props.onViewDetails) {
            this.props.onViewDetails(planning);
        }
    };

    handleDeleteClick = (planning: Planning) => {
        this.setState({
            deleteDialogOpen: true,
            planningToDelete: planning
        });
    };

    handleDeleteConfirm = () => {
        if (this.props.onDelete && this.state.planningToDelete) {
            this.props.onDelete(this.state.planningToDelete.id!);
        }
        this.setState({
            deleteDialogOpen: false,
            planningToDelete: null
        });
    };

    handleDeleteCancel = () => {
        this.setState({
            deleteDialogOpen: false,
            planningToDelete: null
        });
    };

    render() {
        const { data, totalItems, pageNum, pageSize } = this.props;
        const { deleteDialogOpen, planningToDelete } = this.state;

        return (
            <>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Total KM</TableCell>
                            <TableCell>Vehículos</TableCell>
                            <TableCell>Cajas</TableCell>
                            <TableCell>Conductores</TableCell>
                            <TableCell>Días</TableCell>
                            <TableCell>Fecha inicio</TableCell>
                            <TableCell>Fecha fin</TableCell>
                            <TableCell>Acciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data && data.length > 0 ? (
                            data.map((planning: Planning) => {

                                return (
                                    <TableRow key={planning.id} hover>
                                        <TableCell>
                                            <Typography variant="body2">
                                                {planning.id || 'N/A'}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                {planning.totalKm.toFixed(2)} km
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Chip 
                                                label={planning.totalVehicles} 
                                                color="primary" 
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                {planning.totalBoxes} cajas
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Chip 
                                                label={planning.routings.length} 
                                                color="secondary" 
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                {planning.totalDays}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                {planning.planningDate ? (() => {
                                                    const date = new Date(planning.planningDate);
                                                    const day = String(date.getUTCDate()).padStart(2, '0');
                                                    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                                                    const year = date.getUTCFullYear();
                                                    return `${day}/${month}/${year}`;
                                                })() : 'N/A'}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">
                                                {planning.planningEndDate ? (() => {
                                                    const date = new Date(planning.planningEndDate);
                                                    const day = String(date.getUTCDate()).padStart(2, '0');
                                                    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                                                    const year = date.getUTCFullYear();
                                                    return `${day}/${month}/${year}`;
                                                })() : 'N/A'}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <IconButton
                                                onClick={() => this.handleViewDetails(planning)}
                                                title="Ver detalles"
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                            {planning.id && (
                                                <IconButton
                                                    onClick={() => this.handleDeleteClick(planning)}
                                                    title="Eliminar"
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        ) : (
                            <TableRow>
                                <TableCell colSpan={7}>
                                    <Typography variant="body2" color="textSecondary">
                                        No hay planificaciones disponibles
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={totalItems}
                    page={pageNum}
                    onChangePage={this.handlePageChange}
                    rowsPerPage={pageSize}
                    onChangeRowsPerPage={this.handleRowsPerPageChange}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    labelRowsPerPage="Filas por página:"
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                />

                {/* Modal de confirmación de eliminación */}
                <Dialog
                    open={deleteDialogOpen}
                    onClose={this.handleDeleteCancel}
                    aria-labelledby="delete-dialog-title"
                >
                    <DialogTitle id="delete-dialog-title">
                        Confirmar eliminación
                    </DialogTitle>
                    <DialogContent>
                        <Typography>
                            ¿Está seguro de que desea eliminar la planificación con ID: {planningToDelete && planningToDelete.id}?
                        </Typography>
                        <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                            Esta acción no se puede deshacer.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleDeleteCancel} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={this.handleDeleteConfirm} color="secondary" variant="contained">
                            Eliminar
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TablePlanningComponent.tsx